export const PageHead = ({ title, subtitle, children }) => (
  <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
    <div>
      <h1 className="font-display text-3xl font-semibold tracking-tight text-white">{title}</h1>
      {subtitle && <p className="mt-2 text-sm text-slate-400">{subtitle}</p>}
    </div>
    {children}
  </div>
);
